var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.role_id === 1)?_c('AdminDashboard',{attrs:{"type":"health"}}):(_vm.user.role_id === 2)?_c('Dashboard',{attrs:{"type":"health"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }